// Browser polyfills for the Solana / Anchor stack (@coral-xyz/anchor, bn.js,
// @solana/web3.js, @solana/spl-token). Those libraries assume the Node globals
// `Buffer`, `global`, and `process`, which Vite does not provide in the
// browser — surfacing at runtime as "Buffer is not defined" the moment an
// Anchor instruction is encoded (e.g. the SVM `fin_transfer`).
//
// MUST be imported FIRST in the entry (main.tsx), before any module that pulls
// in the Solana SDK, so the globals exist before that code evaluates.
import { Buffer } from "buffer";

// Loose cast so we don't clash with @types/node's global `Buffer`/`process`
// declarations — we only need to set these globals when missing (browser).
const g = globalThis as unknown as Record<string, unknown>;

if (!g.Buffer) g.Buffer = Buffer;
if (!g.global) g.global = globalThis;
if (!g.process) g.process = { env: {} };
